import { apiUrl } from '../config/api';
import { apiFetch } from './client';

const API_BASE = apiUrl('/api/plans');

export async function getPlans(teacherId) {
  const response = await apiFetch(`${API_BASE}/teacher/${teacherId}`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des plans');
  }
  return response.json();
}

export async function submitPlan(formData) {
  const response = await apiFetch(`${API_BASE}/submit`, {
    method: 'POST',
    auth: true,
    body: formData,
  });
  if (!response.ok) {
    if (response.status === 413) {
      throw new Error('Fichier trop volumineux pour la configuration serveur (Nginx). Contactez l\'administrateur.');
    }
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Téléversement impossible');
  }
  return response.json();
}

export async function getChefEquipes() {
  const response = await apiFetch(`${API_BASE}/chefs`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des chefs');
  }
  return response.json();
}

export async function getComments(planId) {
  const response = await apiFetch(`${API_BASE}/${planId}/comments`, {
    auth: true,
  });
  if (!response.ok) {
    throw new Error('Erreur lors du chargement des commentaires');
  }
  return response.json();
}

export async function deletePlan(planId) {
  const response = await apiFetch(`${API_BASE}/${planId}`, {
    method: 'DELETE',
    auth: true,
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Impossible de supprimer le plan');
  }
  return response.json();
}

export async function updatePlan(planId, formData) {
  const response = await apiFetch(`${API_BASE}/${planId}`, {
    method: 'PUT',
    auth: true,
    body: formData,
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.detail || 'Impossible de modifier le plan');
  }
  return response.json();
}
